
/**
 * @export
 * @class Settings
 */

import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export namespace Settings {

  export abstract class DateFormats {
    public static readonly dateFormatBackend = "DD-MM-yyyy";
    public static readonly dateFormatFrontend = "yyyy-MM-DD HH:mm:ss";
    public static readonly dateFormatOnlyDate = "yyyy-MM-DD";
    public static readonly dateFormatOnlyDateVelocity = "MM/DD/yyyy";
  }
  export abstract class AutoRefreshTime {
    public static readonly refreshTimeInMilliSeconds = 900000; //900000 milli-seconds are 15 minutes
  }
  export abstract class GridConfiguration {
    public static readonly pageNumber: number = 1;
    public static readonly pageSize: number = 10;
    public static readonly pageSizeList: number[] = [10,25,50, 100];
    public static readonly totalRecords: number = 0;
    public static readonly orderBy: String = "";
    public static readonly orderType: Number = 1;
    public static readonly ticketLogColumns: {}[] = [{ header: 'Code', field: 'logs_code', class: "error-code" }, { header: 'Description', field: 'description', class: "error-message" }, { header: "Data", field: "trace_message", class: "trace-message" }];
    public static readonly approvalLogColumns: {}[] = [{ header: 'Approval Stage', field: 'approval_stage', class: "error-code" }, { header: 'Remarks', field: 'remarks', class: "error-message" }, { header: "Action By", field: "action_by", class: "trace-message" }, { header: "Action On", field: "action_on", class: "trace-message" }];
    public static readonly userActionLogColumns: {}[] = [{ header: "Action By", field: "created_by" },
  { header: "Action On (UTC)", field: "created_on" },
  { header: "Action", field: "action_type" },
  // { header: "Remarks", field: "remark" }
]
   public static readonly dataChangeLoggerColumns: {}[] = [{ header: "Document Field", field: "created_by" },
  { header: "Action On (UTC)", field: "created_on" },
  { header: "Action", field: "action_type" },
  { header: "Remarks", field: "remark" }]
  }

  export abstract class Status {
    public static readonly booleanStatusList: {}[] = [{ value: true, name: "Active" }, { value: false, name: "InActive" }]
    public static readonly booleanList: {}[] = [{ value: true, name: "True", code: "YES" }, { value: false, name: "False", code: "NO" }]
  }
  export abstract class LOB {
    public static readonly lobOptions: { lob_type: number; name: string }[] = [
      { lob_type: 10, name: "Velocity" },
      { lob_type: 20, name: "Sertica" },
      { lob_type: 30, name: "LSRetail" },
      { lob_type: 40, name: "Sertica and LSRetail" },
      { lob_type: 50, name: "D365" }
    ];
  }
  export abstract class LeLOBTypes {
    public static readonly LeLobTypes: { lob_type: number; name: string, isDisabled: boolean }[] = [
      { lob_type: 50, name: "D365FO", isDisabled: true },
      { lob_type: 10, name: "Velocity", isDisabled: false },
      { lob_type: 20, name: "Sertica", isDisabled: false },
      { lob_type: 30, name: "LS Retail", isDisabled: false },
    ];
  }
  export abstract class DATATYPES {
    public static readonly DataTypesEnum: { value: number; name: string }[] = [{ value: 10, name: "INT" }, { value: 20, name: "STR" }, { value: 30, name: "BOOLEAN" }, { value: 40, name: "FLOAT" }]
  }
  export abstract class TicketTypeEnum {
    public static readonly requestTypes: {}[] = [{value:40, name:"BLOCK"},{ value: 60, name: "EXTEND" },{ value: 50, name: "UNBLOCK" },{value:20,name:"UPDATE"}]
  }

  export enum FormFieldType {
    "input" = "Text Box",
    "dropdown" = "Dropdown",
    "multiselect" = "MultiSelect",
    "radiobutton" = "Radio Button",
    "calendar" = "Calendar"
  }
  export enum FileTypeEnum {
    PDF = 1,
    IMAGE = 2,
    EXCEL = 3,
    CSV = 4,
    WORD = 5,
    JSON = 6,
    ARCHIVE = 7,
    TEXT = 8,
    OTHER = 9
  }

  export enum ActionType {
    D = "DELETE",
    I = "INSERT",
    S = "SELECT/SEARCH",
    U = "UPDATE",
    E = "EXPORT"
  }
  export enum EmailTemplateFormat {
    "Email" = 1,
    "Domain" = 2,
    "Email Regex" = 3
  }
  export enum NotificationType {
  }
  export enum Url {
    "Payment Terms" = 1
  }
  export enum LobType {
    Velocity = 10,
    Sertica = 20,
    LSRetail = 30,
    "Sertica And LSRetail" = 40,
    D365 = 50
  }

  export enum FileType {
    "EDI" = 2,
    "PDF" = 1,
    "XML" = 3
  }
  export enum TicketType {
    "CREATE" = 10,
    "UPDATE" = 20,
    "QUESTIONS" = 30,
    "BLOCK" = 40,
    "UNBLOCK" = 50,
    "EXTEND" = 60,
    "SPECIAL CREATE" = 70,
    "SPECIAL UNBLOCK" = 80,
    "OTHER-OTHER" = 90,
    "OTHER-BULK BLOCK/UPDATE" = 100,
    "EXTEND TO LOB" = 110,
    "CREATE/UPDATE EMPLOYEE VENDOR ACCOUNT" = 120
  }
  export enum VendorChangeLogStatusEnum{
    "PENDING" = 5,
    "READY" = 10,
    "COMPLETED" = 15
  }
  export enum StatusCodeEnum {
    "DRAFT" = 5,
    "VAT VALIDATION STARTED" = 6,
    "SUBMITTED" = 10,

    "PENDING GP APPROVAL" = 15,
    "GP APPROVED" = 20,
    "GP REJECTED" = 25,

    "PENDING SANCTIONS REVIEW" = 26,
    "SANCTION CHECK COMPLETED" = 27,
    "SANCTION CHECK FAILED" = 28,
    "SUPPLIER SANCTION CHECK COMPLETED"=29,
    "PENDING MDM APPROVAL" = 30, //pending mdm team approval
    "MDM APPROVED" = 35, //mdm team approved
    "MDM REJECTED" = 32, //mdmd team rejected

    "INSPECT" = 40,
    "CANCELLED" = 45,
    "COMPLETED" = 50,

    "PENDING SANCTIONS SCREENING" = 60, //pending dg team approval
    "DG APPROVED" = 65, //dg team approved
    "DG REJECTED" = 70, //dg team rejected

    "DATA SENDING TO D365" = 75, //data sending to d365
    "SUPPLIER CREATED IN D365" = 80,
    "MD HANDLING" = 90,
    "UPDATING DATABASE" = 100,
    "ONGOING ADJUSTMENTS" = 95,
    "INCOMPLETE" = 115,
    "SUPPLIER DATABASE UPDATED"=125
  }

  export enum ApprovalStageEnum {
    "VAT APPROVED" = 2,
    "VAT REJECT" = 3,
    "SANCTION APPROVED" = 4,
    "SANCTION FAILED" = 5,
    "MD APPROVED" = 6,
    "MD REJECTED" = 7,
    "GP APPROVED" = 8,
    "GP REJECTED" = 9,
    "SUPPLIER SANCTIONS CHECK COMPLETED" = 10,
    "DG REJECTED" = 11,
    "GP ON HOLD" = 12,
  }

  export enum FlagTypeEnum{
    "LOB" = 5,
    "LOB ONLY" = 10,
    "D365" = 15,
    "D365 ONLY" = 20,
    "LOB AND D365" = 25
  }

  export enum TaxType {
  VAT = 0,
  LTR = 2,
  SSC = 1,
  REGISTRATION_ID = 3,
  ORGANISATION_NUMBER = 4
  }
    export enum TaxExemptDefinition {
        VAT = 0,
        LTR = 2,
        SSC = 1,
    }

  export abstract class TaxTypeOptions {
    public static readonly taxTypeOptions: { value: number; name: string }[] = [
      { value: 0, name: "VAT (Value-added tax)" },
          { value: 2, name: "LTR (Local Tax Registration)" },
      { value: 1, name: "SSC (Social Security Code)" },
       { value: 3, name: "Registration ID" },
        { value: 4, name: "Organisation Number" }
    ];
  }
  export enum ContactType {
  Phone = 1,
  Email = 2
}


  export enum EventEnum {
    "DRAFT" = 5,
    "VAT VALIDATION STARTED" = 6,
    "VAT VALIDATION COMPLETED" = 7,
    "VAT VALIDATION FAILED" = 8,

    "SUPPLIER LOB ADDED" = 10,
    "SUPPLIER DATA SUBMITTED" = 12,

    "PENDING GP APPROVAL" = 15,
    "GP APPROVED" = 20,
    "GP REJECTED" = 25,

    "PENDING SANCTIONS REVIEW" = 26,
    "SANCTION CHECK COMPLETED" = 27,
    "SANCTION CHECK FAILED" = 28,
    "SUPPLIER SANCTION CHECK COMPLETED"=29,
    "PENDING MDM APPROVAL" = 30,
    "MDM REJECTED" = 32,
    "MDM APPROVED" = 35,

    "INSPECT" = 40,
    "CANCELLED" = 45,
    "COMPLETED" = 50,
    "INCOMPLETE" = 115,

    "PENDING MANUAL SANCTIONS REVIEW" = 60,
    "SUPPLIER SANCTIONS CHECK COMPLETED" = 65,
    "DG REJECTED" = 70,

    "DATA SENDING TO D365" = 75,
    "SUPPLIER CREATED IN D365" = 80,
    "MD HANDLING" = 90,
    "ONGOING ADJUSTMENTS" = 95,
    "UPDATING DATABASE" = 100,

    "OUTPUT GENERATED"= 71,
    "OUTPUT GENERATED FAILED"=72,

    "SUPPLIER UNBLOCK STARTED" = 105,
    "SUPPLIER BLOCK STARTED" = 110,
    "SUPPLIER DATABASE MAPPING UPDATED"=120,
    "SUPPLIER DATABASE UPDATED"=125
  }
//   export enum VendorChangeLogStatusEnum{
//     "PENDING" = 5,
//     "READY" = 10,
//     "COMPLETED" = 15
//   }
  export enum EmailStatusEnum {
    "PENDING GP APPROVAL" = 15,
    "GP REJECTED" = 25,
    "MDM REJECTED" = 32,
    "CANCELLED" = 45,
    "COMPLETED" = 50,
    "PENDING SANCTIONS SCREENING" = 60,
    "DG REJECTED" = 70,
    "ONGOING ADJUSTMENTS" = 95,
  }

  export enum Module {
    "ANNOUNCEMENT_ADMIN" = 230,
    "AUTO_EMAIL_TEMPLATE" = 760,
    "APP_CONFIGURATION" = 610,
    "COLUMN_CONFIGURATION" = 160,
    "COUNTRY" = 90,
    "CURRENCY" = 80,
    "CONTACT_INFO_PURPOSE"= 810,
    "D365_MD_CHANGE_LOG" = 740,
    "D365_SUPPLIER" = 290,
    "EMAIL_CONTROLLER" = 520,
    "EMAIL_LOG" = 770,
    "ERROR_CODE_LIST" = 460,
    "FIELD_USAGE_ACROSS_SYSTEM" = 440,
    "GROUP_PROCUREMENT_APPROVERS" = 170,
    // "INFO_MESSAGE_ERROR_MESSAGE" = 560,
    "LE_BU_CONFIGURATION" = 370,
    "LEGAL_ENTITY" = 40,
    "GLOBAL_FIELDS_CONFIGURATION" = 820,
    "LS_RETAIL_DATABASE" = 730,
    "LS_RETAIL_INPUT_FIELDS" = 270,
    "MANUAL_EMAIL_TEMPLATE" = 750,
    "MASTER_STATUS" = 470,
    "METHOD_OF_PAYMENT" = 220,
    "METHOD_OF_PAYMENT_SCRIPT" = 410,
    "NOTIFICATION_LOG" = 790,
    "RECORD_TRACKER" = 11,
    "ROLES_ADMIN" = 10,
    "REASON_CODES" = 180,
    "SALES_TAX_GROUPS" = 190,
    "SALES_TAX_GROUP_SCRIPT" = 420,
    "SERTICA_DATABASE" = 720,
    "SERTICA_INPUT_FIELDS" = 240,
    "SERTICA_LE_CONFIGURATION" = 380,
    "SERTICA_UNITS_CONFIGURATION" = 260,
    "SLA" = 530,
    "TERMS_OF_PAYMENT" = 280,
    "UPDATE_REQUEST_LOG" = 800,
    "USER_ACTIVITY_ADMIN" = 150,
    "USERS_ADMIN" = 50,
    "VELOCITY_DATABASE" = 710,
    "VELOCITY_INPUT_FIELDS" = 250,
    "VELOCITY_ORGANISATION_CONFIGURATION" = 100,
    "VELOCITY_SCRIPT" = 400,
    "SUPPLIER_CHANGE_LOG" = 490,
    "SUPPLIER_MDM" = 30,
    "SPECIAL_LOB_DATABASE" = 840,
    // "APPLICATION_CONFIGURATION" = 610,
}
  export enum DataChangeLoggerModule {
    "DOCUMENTS" = 10
  }
  export enum MasterModule {
    ROLE_MANAGEMENT = 10,
    // PRIVILEGE = 20,
    // ROLE_PRIVILEGE = 30,
    APPLICATION = 40,
    USER_MANAGEMENT = 50,
    RETENTION_POLICY = 55,
    DOCUMENT_MANAGEMENT = 60,
    DOCUMENT_TYPE = 70,
    // BLOB_FOLDER = 80,
    DOCUMENT_METADATA = 90,
    FILE_TYPE = 100,
    // ROLE_USER = 110,
    COLUMN_SETTINGS = 120,
    // DOCUMENT_FIELD_LIBRARY = 130,
    SEARCH_DOCUMENT_LIST = 140,
    DOCUMENT_EMAIL = 160,
    SYSTEM_ANNOUNCEMENT = 165,
    DATA_CHANGE_LOGGER = 175,
    USER_ACTIVITY_LOGS = 180,
    FILTER_TEMPLATES = 190,
    // LEGAL_ENTITY_DOCUMENT_TYPE_RELATION = 170,
  }

  export enum EnvironmentType {
    "DEV" = 1,
    "PROD" = 2,
    "TEST" = 3,
    "UAT" = 4,
    "TRAIN" = 5
  }
  export abstract class RegexPattern {
    public static readonly removeSpace: any = /^(?!\s+$).+/;
    public static readonly whiteSpace: any = /^(?!\s*$)[\s\S]+/;
    public static readonly validMultipleEmail: any = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    public static readonly validEmail: any = /^(?! )[a-zA-Z0-9_\.#$%&^`{|}~\+\-/\!\'*\+\-\/=\?\"]+@([a-zA-Z0-9-]+[.]){1,2}[a-zA-Z]+ *$/;
    public static readonly validPhone: any = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,50}$/;
    public static readonly removeSpecialCharacters: any = /^[a-zA-Z0-9]{4,10}$/;
    public static readonly DomainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    public static readonly CommaSeparatedPositiveNumbers: any = /^(\s*\d{1,3}\s*(,\s*\d{1,3}\s*)*)?$/;
    public static readonly MultipleValidEmail: any = /^([a-zA-Z0-9+.\-\_]+@[a-zA-Z0-9\-\_]+\.[a-zA-Z0-9.\-\_]+)((,| ,|, | , |){1}[a-zA-Z0-9+.\-\_]+@[a-zA-Z0-9\-\_]+\.[a-zA-Z0-9.\-\_]+)*$/;
    public static multipleEmailValidator(defaultLength=255,checkMaxMail=true): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        const value = control.value;

        if (!value) {
            return null;
        }

        // Max length 255
        if (value.length > defaultLength) {
            return {
                maxLength: true
            };
        }

        // No spaces allowed
        if (/\s/.test(value)) {
            return {
                spacesNotAllowed: true
            };
        }

        // Semicolon should not be at end
        if (value.endsWith(';')) {
            return {
                trailingSemicolon: true
            };
        }

        // Split emails
        const emails = value
            .split(';')
            .filter((email: string) => email?.trim());

        // Max 4 emails
        if(checkMaxMail){
        if (emails.length > 4) {
            return {
                maxEmailsExceeded: true
            };
        }
      }

        // Email validation
        const emailRegex =
            /^[a-zA-Z0-9._+\-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

        const invalidEmail = emails.some(
            (email: string) => !emailRegex.test(email)
        );

        if (invalidEmail) {
            return {
                invalidEmail: true
            };
        }

        return null;
    };
}
  }

  export enum RequesterType {
    "REQUESTER" = 5,
    "SUBSCRIBER" = 10,
    "GROUP PROCUREMENT" = 15,
    "MASTER DATA TEAM" = 20
  }

  export abstract class RequesterTypeOptions {
    public static readonly requesterTypeOptions: { value: number; name: string }[] = [
      { value: 5, name: "REQUESTER" },
      { value: 10, name: "SUBSCRIBER" },
      { value: 15, name: "GROUP PROCUREMENT" },
      { value: 20, name: "MASTER DATA TEAM" },
      { value: 25, name: "SERTICA CONNECT USER" },
      {value:30,name:"DATA GOVERNANCE TEAM"}
    ];
  }

   export abstract class RejectionReason {
    public static readonly rejectionReasonOptions: { value: number; name: string }[] = [
      { value: 10, name: "BLOCK REQUEST JUSTIFICATION REASONS" },
      { value: 15, name: "UNBLOCK REQUEST JUSTIFICATION REASON" },
      { value: 20, name: "GROUP PROCUREMENT REJECTION REASONS" },
      { value: 30, name: "MD REJECTION REASONS" },
      { value: 40, name: "DATA GOVERNANCE REJECTION REASONS" },
      { value: 50, name: "SUPPLIER CREATION REASON" },
    //   { value: 60, name: "MD CANCELLATION REASON"}
    ];
  }

  export enum Type {
    "None" = 0,
    "Phone" = 1,
    "Email" = 2,
    "URL" = 3,
    "Telex" = 4,
    "Fax" = 5,
    "Facebook" = 6,
    "Twitter" = 7,
    "LinkedIb" = 8
  }
}
